window.addEventListener('load', () => {
  const widgetArticlesCarrousel = new Swiper(
    '.widget-articles__carrousel__swiper',
    {
      slidesPerView: 3,
      spaceBetween: 15,
      navigation: {
        nextEl: '.widget-articles__carrousel .swiper-button-next',
        prevEl: '.widget-articles__carrousel .swiper-button-prev',
      },

      breakpoints: {
        0: {
          slidesPerView: 1,
          spaceBetween: 0,
        },
        768: {
          slidesPerView: 2,
          spaceBetween: 25,
        },
        992: {
          slidesPerView: 3,
          spaceBetween: 15,
        },
      },
    }
  );
});
